import { createRequest, RequestConfig } from 'app/common/api';

import { TTariffZonesConstraints } from '../core/tariff-zones-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_tariff_zones',
};

export const getTariffZonesRequest = (constraints?: TTariffZonesConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
